/**
 * Общие хелперы текстовых шаблонов аналитических записок (ВЭД).
 * Сюда — только то, что совпадает в Base и Monthly.
 */

export const ANALYTICS_NOTES_UNDEFINED_NUMBER_LABEL = '(неопределено)';

export type TAnalyticsNotesFormattableNumber = string | number | null | undefined;

export const isAnalyticsNotesUndefinedNumber = (value: TAnalyticsNotesFormattableNumber): boolean => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }

  return Number.isNaN(Number(value));
};

export const hasUndefinedMetricGroupValue = (...metricValues: TAnalyticsNotesFormattableNumber[]): boolean =>
  metricValues.some(isAnalyticsNotesUndefinedNumber);

export const formatAnalyticsNotesNumberOrUndefined = (
  value: TAnalyticsNotesFormattableNumber,
  formatFn: (numericValue: number) => string,
): string => {
  if (isAnalyticsNotesUndefinedNumber(value)) {
    return ANALYTICS_NOTES_UNDEFINED_NUMBER_LABEL;
  }

  return formatFn(Number(value));
};

export const resolveAnalyticsNotesTrendOrUndefined = <T extends string>(
  value: TAnalyticsNotesFormattableNumber,
  resolve: (numericValue: number) => T,
): T | typeof ANALYTICS_NOTES_UNDEFINED_NUMBER_LABEL => {
  if (isAnalyticsNotesUndefinedNumber(value)) {
    return ANALYTICS_NOTES_UNDEFINED_NUMBER_LABEL;
  }

  return resolve(Number(value));
};

export const formatAnalyticsNotesDisplayNumber = (value: TAnalyticsNotesFormattableNumber): string =>
  formatAnalyticsNotesNumberOrUndefined(value, (numericValue) => String(numericValue));

/** Признак изменения оборота / импорта (Y−1 к Y−2) — одинаков в Base и Monthly. */
export const getAnalyticsNotesTradeChangeVerb = (value: TAnalyticsNotesFormattableNumber): string =>
  resolveAnalyticsNotesTrendOrUndefined(value, (numericValue) => {
    if (numericValue > 0) return 'увеличился';
    if (numericValue < 0) return 'уменьшился';
    return 'не увеличился';
  });

/** Признак изменения экспорта (Y−1 к Y−2) — одинаков в Base и Monthly. */
export const getAnalyticsNotesExportChangeVerb = (value: TAnalyticsNotesFormattableNumber): string =>
  resolveAnalyticsNotesTrendOrUndefined(value, (numericValue) => {
    if (numericValue > 0) return 'возрос';
    if (numericValue < 0) return 'уменьшился';
    return 'не возрос';
  });
